import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Format a number with the specified number of decimal places
 */
export function formatNumber(value: number | null | undefined, decimals = 1): string {
  if (value === null || value === undefined) return "-"
  return value.toFixed(decimals)
}
